import { useContext } from 'react';
import { useIsBelowMd } from 'hooks/use-is-below-md';
import { GridTasksContext, GridTasksContextValue } from './components/grid-tasks-provider';
import { IDataGridCardMode } from './model';

export const useDataGridTasks = <T extends Record<string, any> = any>() => {
  const context = useContext<GridTasksContextValue<T> | null>(GridTasksContext);

  if (!context) {
    throw new Error('GridTasksContext is required');
  }

  return context;
};

/**
 * The card-mode switch (Phase F1, D-10 / D-53; N2b, PD-10): true below `md`
 * unless the config opted out (`cardMode: false`). A config without a
 * declaration card-renders with the automatic anatomy; every grid keeps its
 * table at and above `md`. The edge is the theme's, shared with the SCSS map
 * (rules/responsive.md).
 */
export const useDataGridCardMode = (
  cardMode: IDataGridCardMode | false | null | undefined,
): boolean => {
  const isBelowMd = useIsBelowMd();
  return cardMode !== false && isBelowMd;
};
